import { useMemo } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { useEditCanvasStore } from '../../store';
import { type useAlignNodes } from '../commands/hooks/useAlignNodes';
import { useIsMultiSelected } from '../useIsMultiSelected';

export function useAlignmentShortcuts(alignNodes: ReturnType<typeof useAlignNodes>) {
  const isMultiSelected = useIsMultiSelected();
  const readOnly = useEditCanvasStore((state) => state.readOnly);
  const { onAlignBottom, onAlignHorizontalCenter, onAlignLeft, onAlignRight, onAlignTop, onAlignVerticalCenter } =
    alignNodes;

  const options = useMemo(
    () => ({ enabled: isMultiSelected && !readOnly, preventDefault: true }),
    [isMultiSelected, readOnly],
  );

  // Selection-relative alignment
  useHotkeys('alt+w', () => onAlignTop(false), options, [onAlignTop]);
  useHotkeys('alt+a', () => onAlignLeft(false), options, [onAlignLeft]);
  useHotkeys('alt+s', () => onAlignBottom(false), options, [onAlignBottom]);
  useHotkeys('alt+d', () => onAlignRight(false), options, [onAlignRight]);
  useHotkeys('alt+v', () => onAlignVerticalCenter(false), options, [onAlignVerticalCenter]);
  useHotkeys('alt+h', () => onAlignHorizontalCenter(false), options, [onAlignHorizontalCenter]);

  // Viewport-relative alignment (Shift held)
  useHotkeys('shift+alt+w', () => onAlignTop(true), options, [onAlignTop]);
  useHotkeys('shift+alt+a', () => onAlignLeft(true), options, [onAlignLeft]);
  useHotkeys('shift+alt+s', () => onAlignBottom(true), options, [onAlignBottom]);
  useHotkeys('shift+alt+d', () => onAlignRight(true), options, [onAlignRight]);
  useHotkeys('shift+alt+v', () => onAlignVerticalCenter(true), options, [onAlignVerticalCenter]);
  useHotkeys('shift+alt+h', () => onAlignHorizontalCenter(true), options, [onAlignHorizontalCenter]);
}
